import React from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import BannerEditForm from "./BannerEditForm";
import { BANNER_FORM_TEXTS } from "../shared/constants";
import { CommonBoxStyles } from "../shared/styledComponents";

const BannerEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <PageLayout showSearch={false}>
        <CommonBoxStyles>
          <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
            {BANNER_FORM_TEXTS.notFound}
          </Typography>
        </CommonBoxStyles>
      </PageLayout>
    );
  }

  return (
    <PageLayout showSearch={false}>
      <BannerEditForm id={id} />
    </PageLayout>
  );
};

export default BannerEditPage;
